import {useEffect} from 'react'
import {useAppDispatch, useAppSelector} from '@/hooks/redux'
import {SET_ERROR_MODAL_BY_CATCH} from '@/store/slices/storage'
import useAcceptModal from '@/hooks/modalAccept'
import {showErrorModal} from '@/components/Modals/ErrorModal'

const ErrorModalListener = () => {
  const errorCode = useAppSelector((state) => state.storage.modalErrorCode)
  const dispatch = useAppDispatch()
  const {setAcceptModal} = useAcceptModal()

  useEffect(() => {
    if (errorCode && typeof errorCode === 'object' && 'message' in errorCode) {
      const errorMessage = {
        message: errorCode.message,
        description:
          'description' in errorCode ? errorCode.description : undefined,
      }
      console.log(errorMessage)

      dispatch(SET_ERROR_MODAL_BY_CATCH(null))
      showErrorModal(errorMessage, setAcceptModal)
    }
  }, [errorCode])

  return null
}

export default ErrorModalListener
